import { render, staticRenderFns } from "./TreatmentPlanModal.vue?vue&type=template&id=1e925018&"
import script from "./TreatmentPlanModal.vue?vue&type=script&lang=js&"
export * from "./TreatmentPlanModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports